import { render, staticRenderFns } from "./SerialDetail.vue?vue&type=template&id=403e100c"
import script from "./SerialDetail.vue?vue&type=script&lang=js"
export * from "./SerialDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports